import { createSelector } from "reselect";
import { ApplicationState, CommonState } from "@idw-types/state";

export const getCommonState = (state: ApplicationState) => {
	return state.common;
};

export const getRedirectUrl = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.redirectUrl;
});

export const getVerificationError = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.verificationError || null;
});

export const getShouldUpdateSubmitButton = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.shouldUpdateSubmitButton;
});

export const getCustomHeaderHtml = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.customHeaderHTML || null;
});

export const getCustomFooterHtml = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.customFooterHTML || null;
});

export const getLandingPageData = createSelector(getCommonState, (commonState: CommonState) => {
	return commonState.landingPageData || null;
});